module.exports = __webpack_public_path__ + "static/scale-model-of-ellen-kenna-house-in-berkeley-california-0eb2346448b470b3d9955e114eaa0a9f.png";